import PropTypes from 'prop-types';
import { useTranslation } from 'react-i18next';
import { ActionIconButton } from '@core/components/ui';

/**
 * FAQ Table Actions Component
 *
 * Renders action buttons for FAQ operations (edit, delete).
 * Used in the Actions column of the FAQTable.
 *
 * @param {Object} props
 * @param {Function} props.onEdit - Edit handler
 * @param {Function} props.onDelete - Delete handler
 *
 * @example
 * <FAQTableActions
 *   onEdit={() => handleEdit(faq)}
 *   onDelete={() => handleDelete(faq)}
 * />
 */
export function FAQTableActions({ onEdit, onDelete }) {
  const { t } = useTranslation();

  return (
    <div className="flex items-center gap-2">
      <ActionIconButton
        icon="lucide:edit"
        onClick={onEdit}
        tooltip={t('faq.edit', 'Edit')}
        variant="default"
        ariaLabel={t('faq.edit', 'Edit')}
      />
      <ActionIconButton
        icon="lucide:trash-2"
        onClick={onDelete}
        tooltip={t('faq.delete', 'Delete')}
        variant="danger"
        ariaLabel={t('faq.delete', 'Delete')}
      />
    </div>
  );
}

FAQTableActions.propTypes = {
  onEdit: PropTypes.func.isRequired,
  onDelete: PropTypes.func.isRequired,
};
